import { useEffect, useState } from "react";

export function ReadingProgress() {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const onScroll = () => {
            const el = document.documentElement;
            const total = el.scrollHeight - el.clientHeight;
            setProgress(total > 0 ? (el.scrollTop / total) * 100 : 0);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        // A fat lime bar in a black-ruled gutter — readable as a physical meter.
        <div
            className="fixed top-0 left-0 right-0 z-[60] h-2 bg-canvas border-b-2 border-foreground"
            data-testid="reading-progress"
        >
            <div
                className="h-full bg-accent border-r-2 border-foreground transition-[width] duration-75 ease-linear"
                style={{ width: `${progress}%` }}
            />
        </div>
    );
}
